import React from "react";
import { Link } from "react-router-dom";

const brands = ["LG", "Samsung", "IFB", "Whirlpool", "Bosch"];
const brandLinks = {
  LG: "/lg-appliance-service-bangalore",
  Samsung: "/samsung-appliance-repair-bangalore",
  IFB: "/ifb-appliance-repair-bangalore",
  Whirlpool: "/whirlpool-appliance-repair-bangalore",
  Bosch: "/bosch-appliance-repair-bangalore",
};

const Brands = () => {
  return (
    <section className="relative py-24 overflow-hidden bg-gradient-to-br from-[#F9FAFB] via-[#eef4ff] to-[#ffffff]">

      <div className="container mx-auto px-6 lg:px-16">

        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-6xl font-black text-slate-900">
            Brands We{" "}
            <span className="bg-gradient-to-r from-[#0F52BA] to-[#FF6B00] bg-clip-text text-transparent">
              Service
            </span>
          </h2>

          <p className="text-slate-600 mt-4">
            We repair all major appliance brands with certified technicians.
          </p>
        </div>

        {/* BRAND LINKS */}
        <div className="flex flex-wrap justify-center gap-6">
          {brands.map((brand, index) => (
            <Link
              key={index}
              to={brandLinks[brand]}
              className="px-8 py-4 rounded-full text-lg font-semibold 
              bg-white shadow-md text-slate-800 border border-slate-200
              hover:bg-[#0F52BA] hover:text-white hover:border-[#0F52BA]
              hover:scale-110 transition-all duration-300"
            >
              {brand}
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Brands;
